// The free-plan watermark badge (B1 soft brand chip, "Made with WaveGen").
// Previews composite the SAME PNG the server uses for exports/publishes, so
// what users see in the editor is pixel-identical to what goes out. The
// object is public in Storage (regenerated via server/scripts/generateWatermark.ts).
export const WATERMARK_STORAGE_PATH = "wavegen-watermark.png";
export const WATERMARK_PUBLIC_URL =
  "https://storage.googleapis.com/wavegen-4f28f.appspot.com/wavegen-watermark.png";

// Placement must match server/src/utils/watermarkUtils.ts createWatermarkOverlay()
export const WATERMARK_POSITION = { x: 39, y: 95 };
export const WATERMARK_WIDTH_PCT = 22;
